import { render, staticRenderFns } from "./chart5.vue?vue&type=template&id=53f5f906&scoped=true&"
import script from "./chart5.vue?vue&type=script&lang=js&"
export * from "./chart5.vue?vue&type=script&lang=js&"
import style0 from "./chart5.vue?vue&type=style&index=0&id=53f5f906&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f5f906",
  null
  
)

export default component.exports